// logo
import logo from "../Assets/logo.png";

export const Logo = () => {
    return (
        <div className="logo-wrap">
            <div className="logo">
                <img src={logo} alt="logo" />
            </div>
            <div className="text">
                <h3>Page Partners</h3>
                <p>People First.</p>
            </div>
        </div>
    );
}